"use strict";

var dependencies = ['$q', 'inviteToApplyDataService'];

function InviteToApplyMsgForm(formName, $scope) {
    var self = this;
    var inviteToApplyDataService = dependencies['inviteToApplyDataService'];
    var $q = dependencies['$q'];
    var brandId;
    var systemTemplates;
    var jobFirstTimeChange = true;

    self.loadData = function (data) {
        brandId = data.brandId;
        init();
    };

    self.loadBrandTemplates = function (brand) {
        if (!jobFirstTimeChange) {
            self.data.template = null;
        }
        jobFirstTimeChange = false;

        inviteToApplyDataService.getBrandMessageTemplates(brand.id, "ALL", "INVITE_TO_APPLY")
            .then(function (res) {
                self.templates = systemTemplates.concat(res.message_templates || []);
            }, function (err) {
                console.error(err);
            });
    };

    self.validateThenGetData = function () {
        var deferred = $q.defer();

        if (self.validator.validate()) {
            deferred.resolve(self.data);
        } else {
            deferred.reject("VALIDATION_ERROR");
        }

        return deferred.promise;
    };

    var init = function () {
        var promises = {};
        promises['systemTemplates'] = inviteToApplyDataService.getSystemInviteToApplyTemplates();
        promises['SmartFields'] = inviteToApplyDataService.getTemplateSmartFields("INVITE_TO_APPLY");

        $q.all(promises)
            .then(function (res) {
                systemTemplates = res['systemTemplates'] || [];
                self.smartFields = res['SmartFields'] || [];
                self.templates = systemTemplates;
                if (systemTemplates && systemTemplates.length) {
                    self.data.template = systemTemplates[0];
                    self.selectTemplate();
                }
            }, function (err) {
                console.error(err);
            });
    };

    self.selectTemplate = function () {
        if (self.data.template) {
            self.data.subject = self.data.template.subject;
            self.data.body = self.data.template.message;
        }
    };

    self.onMessageBodyChanged = function (value) {
        delete self.data.template;
        self.data.body = value;
    };

    self.onMessageSubjectChanged = function (value) {
        delete self.data.template;
        self.data.subject = value;
    };

    self.destroy = function () {
        self.data = {};
        self.isLoading = false;
    };
}

var InviteToApplyMsgFormOptions = {
    form: InviteToApplyMsgForm,
    dependencies: dependencies
};

angular.module('harriApp')
    .run(['hFormsService', function (hFormsService) {
        hFormsService.registerForm("InviteToApplyMsgForm", InviteToApplyMsgFormOptions);
    }]);